var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Footer } from './Flyout.styled';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { getChildrenByType } from 'react-nanny';
var VERSION = '5.5.1';
/** DISPLAY NAME: &lt;Flyout.Footer&gt; */
var FlyoutFooter = function (_a) {
    var automationId = _a.automationId, children = _a.children, _b = _a.__TYPE, __TYPE = _b === void 0 ? 'FlyoutFooter' : _b;
    var citrus2022 = useTheme().citrus2022;
    var isCitron = citrus2022 !== null && citrus2022 !== void 0 ? citrus2022 : false;
    var debug = useCitrusDebug();
    var primary = getChildrenByType(children, ['PrimaryButton']);
    var secondary = getChildrenByType(children, ['SecondaryButton']);
    var borderless = getChildrenByType(children, ['BorderlessButton']);
    var buttons = [];
    if (isCitron) {
        buttons = __spreadArray(__spreadArray(__spreadArray([], borderless, true), secondary, true), primary, true).map(function (x) {
            return React.cloneElement(x, { size: isCitron ? 'medium' : 'small' });
        });
    }
    else {
        buttons = __spreadArray(__spreadArray(__spreadArray([], primary, true), secondary, true), borderless, true);
    }
    return (React.createElement(Footer, __assign({}, getAutomation(automationId), getDebug(debug, __TYPE, VERSION)), buttons));
};
FlyoutFooter.defaultProps = {
    __TYPE: 'FlyoutFooter',
};
export default FlyoutFooter;
